/*
 * @Descripttion: 前缀后缀配置项
 * @Author: shenah
 * @Date: 2023-04-21 18:10:27
 * @LastEditors: shenah
 * @LastEditTime: 2023-08-14 09:36:09
 */

// 需要继承的属性
export const extendDefaultAttr = [
  "fontSize",
  "color",
  "fontWeight",
  "relative",
];
export const createPrefixSuffixRuleConfig = (isShowType = true) => {
  let obj = {
    defaultForm: createOneRule(),
    ruleList: [],
  };
  if (!isShowType) {
    obj.defaultForm.showType = "";
  }
  return obj;
};
export const createOneRule = () => {
  return {
    id: dsf.uuid(),
    rule: "",
    fontSize: "",
    color: "",
    icon: "",
    imgObj: {
      src: "", // 继续用这个字段原来是字符串后面是对象
      width: "20",
      height: "auto",
    },
    showType: "icon",
    content: "",
    fontWeight: "400",
    relative: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
  };
};
